import global from "@/locales/hr-HR/global";
import error403 from "@/locales/hr-HR/errors/403";
import error404 from "@/locales/hr-HR/errors/404";
import error500 from "@/locales/hr-HR/errors/500";
import error503 from "@/locales/hr-HR/errors/503";
import error504 from "@/locales/hr-HR/errors/504";
import maintenance from "@/locales/hr-HR/auth/maintenance";
import toast from "@/locales/hr-HR/toast/toast";
import login from "@/locales/hr-HR/auth/login";
import onboarding from "@/locales/hr-HR/auth/onboarding";
import loginPageSteps from "@/locales/hr-HR/loginPageSteps";
import dashboard from "@/locales/hr-HR/dashboard/dashboard";
import account from "@/locales/hr-HR/account/account";
import mailbox from "@/locales/hr-HR/account/mailbox";
import bankstatement from "@/locales/hr-HR/account/bankstatement";
import myApps from "@/locales/hr-HR/my-apps/myApps";
import about from "@/locales/hr-HR/about/about";
import contactService from "@/locales/hr-HR/about/contactService";
import salesPromotions from "@/locales/hr-HR/sales/promotions";
import brochures from "@/locales/hr-HR/sales/brochures";
import shop from "@/locales/hr-HR/shop/data";
import priceList from "@/locales/hr-HR/shop/priceList";
import staff from "@/locales/hr-HR/dashboard/staff";
import promotions from "@/locales/hr-HR/promotions";
import points from "@/locales/hr-HR/points";
import trainings from "@/locales/hr-HR/trainings/trainings";
import vouchers from "@/locales/hr-HR/vouchers/vouchers";
import media from "@/locales/hr-HR/media/index";
import product from "@/locales/hr-HR/product/index";
import message from "@/locales/hr-HR/message/index";
import commitmentLetter from "@/locales/hr-HR/account/commitmentLetter";
import multiplicator from "@/locales/hr-HR/multiplicator";
import consents from "@/locales/hr-HR/consents/consents";
import investment from "@/locales/hr-HR/investment/data";
import kickback from "@/locales/hr-HR/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  kickback: kickback.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  productBrochures: {
    BDriveTitle: "Slike proizvoda",
    BDriveLinkText: "Poveznica na portal SLIKA PROIZVODA",
  },
}

export default {
  locale: "hr-HR",
  messages,
};
